import React from 'react';
import { Home, Bell, Plus } from 'lucide-react';
import AuthorIdentitySwitcher from './AuthorIdentitySwitcher';
import { useTheme } from '../ThemeContext';


export default function Navigation({
  searchQuery,
  setSearchQuery,
  setView,
  walletConnected,
  showSuccessAnimation,
  handlePlusClick,
  currentUser,
  authors,
  primaryAuthorId,
  onSelectAuthor,
  onDisconnect
}) {
  const { t, isDark } = useTheme();
  return (
    <nav style={{ position: 'sticky', top: 0, backgroundColor: t.navBg, backdropFilter: 'blur(12px)', borderBottom: `1px solid ${t.border}`, zIndex: 50, boxShadow: t.navShadow, transition: 'background-color 0.3s, border-color 0.3s' }}>
      <div className="max-w-7xl mx-auto px-6 py-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* Logo - Left */}
        <div style={{ flex: '0 0 auto' }}>
          <h1 
            className="gradient-text cursor-pointer"
            onClick={() => {
              setView('home');
              window.history.pushState({}, '', '/');
            }}
            style={{ fontSize: '28px', fontWeight: '700', margin: 0 }}
          >
            LIMESTONE
          </h1>
        </div>

        {/* Right Side - Search + Icon Navigation */}
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flex: '1', justifyContent: 'flex-end' }}>
          <input
            type="text"
            placeholder="Search"
            style={{
              backgroundColor: t.surface,
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              outline: 'none',
              width: '300px',
              color: t.text,
              fontFamily: 'Poppins, sans-serif'
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={(e) => e.currentTarget.style.borderColor = t.accent}
            onBlur={(e) => e.currentTarget.style.borderColor = t.borderStrong}
          />
          
          {/* Home Icon */}
          <button
            onClick={() => {
              setView('home');
              window.history.pushState({}, '', '/');
            }}
            style={{
              backgroundColor: 'transparent',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '6px',
              cursor: 'pointer',
              padding: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: t.text,
              width: '32px',
              height: '32px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.borderColor = t.accent}
            onMouseLeave={(e) => e.currentTarget.style.borderColor = t.borderStrong}
          >
            <Home size={18} />
          </button>

          {/* Bell Icon - Only show when connected */}
          {walletConnected && (
            <button
              className={showSuccessAnimation ? 'success-animation' : ''}
              onClick={() => console.log('Notifications coming soon')}
              title="Notifications coming soon"
              style={{
                backgroundColor: 'transparent',
                border: `1px solid ${t.borderStrong}`,
                borderRadius: '6px',
                cursor: 'pointer',
                padding: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: t.text,
                width: '32px',
                height: '32px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = t.accent}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = t.borderStrong}
            >
              <Bell size={18} />
            </button>
          )}

          {/* Plus Icon - Always show */}
          <button
            onClick={handlePlusClick}
            style={{
              backgroundColor: 'transparent',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '6px',
              cursor: 'pointer',
              padding: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: t.text,
              width: '32px',
              height: '32px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.borderColor = t.accent}
            onMouseLeave={(e) => e.currentTarget.style.borderColor = t.borderStrong}
          >
            <Plus size={18} />
          </button>

          {/* Author Identity Switcher - Replaces User icon */}
          {walletConnected && (
            <AuthorIdentitySwitcher
              currentUser={currentUser}
              authors={authors}
              primaryAuthorId={primaryAuthorId}
              onSelectAuthor={onSelectAuthor}
              onNavigateToProfile={() => setView('profile')}
              onDisconnect={onDisconnect}
            />
          )}
        </div>
      </div>
    </nav>
  );
}